import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSidenav } from '@angular/material/sidenav';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { PropertyFilter } from 'src/app/property-filter/interface/property-filter.interface';
import { ShortNumberPipe } from 'src/app/shared/pipe/short-number.pipe';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import constants from 'src/constant.json';
import { PropertyFilterConfig } from '../../config/property-filter.config';
import { PropertyFilterService } from '../../service/property-filter.service';
import { PropertyFilterState } from '../../state/property-filter.state';

@Component({
  selector: 'app-all-filter-sheet',
  templateUrl: './all-filter-sheet.component.html',
  styleUrls: ['./all-filter-sheet.component.scss'],
})
export class AllFilterSheetComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  @ViewChild('scrollableContainer') private scrollableContainer!: ElementRef;

  @Input() applyToUrl: boolean = false;
  @Output() appliedFilters: EventEmitter<any> = new EventEmitter();
  PropertyFilterConfig = PropertyFilterConfig;
  minYearBuilt: any = null;
  maxYearBuilt: any = null;
  currentYear: any = moment().format('YYYY');
  invalidYearBuiltError: boolean = false;
  checkbox1: boolean;
  propertySoldWithin = 30; // Set to 30 to support 1 month as the default value for the SoldWithin select
  allSelected: boolean = false;
  isCheckedAll: boolean;
  selectedFilters: any;
  selectedHomeTypes: string[] = [];
  isSoldValueChanged: boolean = false;
  // defaultFilter: Partial<PropertyFilter> = this.appState.companyInfoValue?.defaultPropertyFilter;
  appliedFilter?: Partial<PropertyFilter>;
  defaultFormValue: any;
  invalidYear: any;
  filterForm = this._fb.group({
    // status: [],
    lPrice: [null, this.minMaxValidator('min', 'hPrice')],
    hPrice: [null, this.minMaxValidator('max', 'lPrice')],
    lBed: [null, this.minMaxValidator('min', 'hBed')],
    hBed: [null, this.minMaxValidator('max', 'lBed')],
    lBath: [null, this.minMaxValidator('min', 'hBath')],
    hBath: [null, this.minMaxValidator('max', 'lBath')],
    homeType: [[]],
    corpOwned: [null],
    occupied: [null],
    lLiving: [null, this.minMaxValidator('min', 'hLiving')],
    hLiving: [null, this.minMaxValidator('max', 'lLiving')],
    lLot: [null, this.minMaxValidator('min', 'hLot')],
    hLot: [null, this.minMaxValidator('max', 'lLot')],
    lParking: [null],
    lTax: [null, this.minMaxValidator('min', 'hTax')],
    hTax: [null, this.minMaxValidator('max', 'lTax')],
    lValue: [null, this.minMaxValidator('min', 'hValue')],
    hValue: [null, this.minMaxValidator('max', 'lValue')],
    lStories: [null, this.minMaxValidator('min', 'hStories')],
    hStories: [null, this.minMaxValidator('max', 'lStories')],
    lOwnDuration: [null, this.minMaxValidator('min', 'hOwnDuration')],
    hOwnDuration: [null, this.minMaxValidator('max', 'lOwnDuration')],
    lLandValue: [null, this.minMaxValidator('min', 'hLandValue')],
    hLandValue: [null, this.minMaxValidator('max', 'lLandValue')],
    lBldgValue: [null, this.minMaxValidator('min', 'hBldgValue')],
    hBldgValue: [null, this.minMaxValidator('max', 'lBldgValue')],
    lSalePrice: [null, this.minMaxValidator('min', 'hSalePrice')],
    hSalePrice: [null, this.minMaxValidator('max', 'lSalePrice')],
    lEstValue: [null, this.minMaxValidator('min', 'hEstValue')],
    hEstValue: [null, this.minMaxValidator('max', 'lEstValue')],
    underprice: [],
    lRent: [null, this.minMaxValidator('min', 'hRent')],
    hRent: [null, this.minMaxValidator('max', 'lRent')],
    lCapRate: [null, this.minMaxValidator('min', 'hCapRate')],
    hCapRate: [null, this.minMaxValidator('max', 'lCapRate')],
    lDistressStart: [null],
    //  hOffMktDays: [],
    lOnMktDays: [null],
    hOnMktDays: [null],
    flipWithin: [null],
    distressWhin: [null],
    isForSale: [null],
    isPreFcl: [null],
    isAuction: [null],
    isReo: [null],
    isHud: [null],
    includePending: [null],
    isForRent: [null],
    soldWithin: [null],
    mortgLTerm: [null, this.minMaxValidator('min', 'mortgHTerm')],
    mortgHTerm: [null, this.minMaxValidator('max', 'mortgLTerm')],
    mortgLPrincipal: [null, this.minMaxValidator('min', 'mortgHPrincipal')],
    mortgHPrincipal: [null, this.minMaxValidator('max', 'mortgLPrincipal')],
    mortgLRate: [null, this.minMaxValidator('min', 'mortgHRate')],
    mortgHRate: [null, this.minMaxValidator('max', 'mortgLRate')],
    mortgRateType: [null],
    mortgLDate: [null],
    mortgHDate: [null],
    mortgLTerm2: [null, this.minMaxValidator('min', 'mortgHTerm2')],
    mortgHTerm2: [null, this.minMaxValidator('max', 'mortgLTerm2')],
    mortgLPrincipal2: [null, this.minMaxValidator('min', 'mortgHPrincipal2')],
    mortgHPrincipal2: [null, this.minMaxValidator('max', 'mortgLPrincipal2')],
    mortgLRate2: [null, this.minMaxValidator('min', 'mortgHRate2')],
    mortgHRate2: [null, this.minMaxValidator('max', 'mortgLRate2')],
    mortgRateType2: [null],
    mortgLDate2: [null],
    mortgHDate2: [null],
    lLtv: [null, this.minMaxValidator('min', 'hLtv')],
    hLtv: [null, this.minMaxValidator('max', 'lLtv')],
    lMortgage: [null, this.minMaxValidator('min', 'hMortgage')],
    hMortgage: [null, this.minMaxValidator('max', 'lMortgage')],
    lLoanBalance: [null, this.minMaxValidator('min', 'hLoanBalance')],
    hLoanBalance: [null, this.minMaxValidator('max', 'lLoanBalance')],
    lMonthlyPayment: [null, this.minMaxValidator('min', 'hMonthlyPayment')],
    hMonthlyPayment: [null, this.minMaxValidator('max', 'lMonthlyPayment')],
    lYearBuilt: [null],
    hYearBuilt: [null],
  });
  maxDate: Date;
  defaultListingTypeFilters: any;
  userDetails: any;
  statusToggleBtnCtrl = new FormControl('forSale');
  bedToggleBtnCtrl = new FormControl((!this.appliedFilter?.hBed && Number(this.appliedFilter?.lBed)) || '');
  bathToggleBtnCtrl = new FormControl((!this.appliedFilter?.hBath && Number(this.appliedFilter?.lBath)) || '');
  showDropdown: any = {
    lPrice: false,
    hPrice: false,
  };

  onDestroyNotifier$: Subject<void> = new Subject<void>();

  constructor(
    private _fb: FormBuilder,
    public appState: AppState,
    public propertyFilterService: PropertyFilterService,
    public propertyFilterState: PropertyFilterState,
    private cdr: ChangeDetectorRef,
    public authorizeService: AuthorizeService,
    public shortNumber: ShortNumberPipe,
    public userState: UserState,
    private subscriptionService: SubscriptionPlanService
  ) {
    this.maxDate = new Date();
  }

  ngOnInit() {
    this.scrollToTop();

    this.userState.userDetail$.subscribe((res) => {
      if (!res) return;
      this.userDetails = res;
    });

    this.propertyFilterState.isFilterSheetOpen$.subscribe((res) => {
      if (res) this.scrollToTop();
    });

    this.updateCapRateControlState();
    this.updateForeclosureControlState();

  }

  formatTooltip(value): string {
    if (value == 0) return value;
    return this.shortNumber?.transform(value);
  }

  ngAfterViewInit(): void {
    this.scrollToTop();

    this.sidenav.openedChange.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((isOpened) => {
      if (isOpened) this._onFilterSheetOpen();
      else this._onFilterSheetClose();
    });

    this.filterForm.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((value) => {
      this._onFilterFormChange(value);
    });

    this.statusToggleBtnCtrl.valueChanges.subscribe((newValue) => {
      if (newValue == 'sold') {
        this.filterForm.patchValue({
          soldWithin: this.appliedFilter?.soldWithin ? this.appliedFilter?.soldWithin : 30,
        });
        this._resetListingTypeValue();
      } else {
        this.filterForm.patchValue({
          soldWithin: null,
        });
        if (newValue == 'rental') {
          this.filterForm.patchValue({
            isForRent: this.appliedFilter?.isForRent ? this.appliedFilter?.isForRent : true,
            isForSale: false,
          });
        } else {
          this.filterForm.patchValue({
            isForRent: false,
            isForSale: this.appliedFilter?.isForSale ? this.appliedFilter?.isForSale : true,
          });
          this._resetListingTypeValue();
        }

        this.isSoldValueChanged = false;
      }
      // Do something with the new value
    });
    this._handleBedBathFilter();
    //   => {this._onFilterFormChange(value) });
  }

  private scrollToTop(): void {
    if (this.scrollableContainer) {
      this.scrollableContainer.nativeElement.scrollTop = 0;
    }
  }

  setListingFilters() {
    this.defaultListingTypeFilters = this.appState.companyInfoValue?.defaultPropertyFilter;
    this.filterForm.patchValue({
      soldWithin: null,
      isForSale: this.appliedFilter.isForSale ? this.appliedFilter.isForSale : this.defaultListingTypeFilters.isForSale,
      isForRent: this.appliedFilter.isForRent ? this.appliedFilter.isForRent : this.defaultListingTypeFilters.isForRent,
      isPreFcl: this.appliedFilter.isPreFcl ? this.appliedFilter.isPreFcl : this.defaultListingTypeFilters.isPreFcl,
      isAuction: this.appliedFilter.isAuction ? this.appliedFilter.isAuction : this.defaultListingTypeFilters.isAuction,
      isReo: this.appliedFilter.isReo ? this.appliedFilter.isReo : this.defaultListingTypeFilters.isReo,
      isHud: this.appliedFilter.isHud ? this.appliedFilter.isHud : this.defaultListingTypeFilters.isHud,
      includePending: this.appliedFilter.includePending
        ? this.appliedFilter.includePending
        : this.defaultListingTypeFilters.includePending,
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  /**
   * @private
   * Any activity to be performed when the filter sheet is opened should be added here.
   */
  _onFilterSheetOpen(): void {
    this.appliedFilter = this.propertyFilterService.getPrimaryFilterFromUrl();
    if (this.appliedFilter?.soldWithin) {
      this.statusToggleBtnCtrl.setValue('sold');
      if (typeof this.appliedFilter?.soldWithin === 'string') {
        this.appliedFilter.soldWithin = Number(this.appliedFilter?.soldWithin);
      }
    } else if (this.appliedFilter?.isForRent) {
      this.statusToggleBtnCtrl.setValue('rental');
    } else {
      this.statusToggleBtnCtrl.setValue('forSale');
    }
    let distressFilter = this.propertyFilterService.hasAnyKey(this.appliedFilter);
    if (distressFilter) {
      this.isCheckLoginIn();
    }
    this.filterForm.patchValue(this.appliedFilter);
    this.setFormControlValue('mortgHDate', this.appliedFilter?.mortgHDate);
    this.setFormControlValue('mortgLDate', this.appliedFilter?.mortgLDate);
    this.setFormControlValue('mortgHDate2', this.appliedFilter?.mortgHDate2);
    this.setFormControlValue('mortgLDate2', this.appliedFilter?.mortgLDate2);
    if (typeof this.appliedFilter?.lBed === 'string' || typeof this.appliedFilter?.hBed === 'string') {
      this.appliedFilter.lBed = Number(this.appliedFilter?.lBed);
      this.appliedFilter.lBath = Number(this.appliedFilter?.lBath);
    }
    if (typeof this.appliedFilter?.soldWithin === 'string') {
      this.appliedFilter.soldWithin = Number(this.appliedFilter?.soldWithin);
    }
    this.bedToggleBtnCtrl.setValue(this.appliedFilter?.lBed);
    this.bathToggleBtnCtrl.setValue(this.appliedFilter?.lBath);
    this.defaultFormValue = JSON.parse(JSON.stringify(this.filterForm.value));
    let jsonObject = this.convertStringBooleans(this.defaultFormValue);
    this.selectedFilters = this.propertyFilterService.getFilterDisplayList(jsonObject);
  }

  isCheckLoginIn() {
    if (!Object.keys(this.userDetails || {}).length) {
      (this.appliedFilter.isPreFcl = null),
        (this.appliedFilter.isAuction = null),
        (this.appliedFilter.isReo = null),
        (this.appliedFilter.isHud = null);
      // this.appliedFilter.isForSale = true;
      if (this.appliedFilter.hPrice) {
        delete this.appliedFilter.hPrice;
      }
    }
  }

  /**
   * @private
   * Any activity to be performed when the filter sheet is closed should be added here.
   */
  _onFilterSheetClose(): void {
    this.filterForm.reset();
    this.selectedFilters = null;
    // this.statusToggleBtnCtrl = new FormControl('forSale');
  }
  /**
   * @private
   */
  _onFilterFormChange(formValue: Partial<PropertyFilter>) {
    let jsonObject = this.convertStringBooleans(formValue);
    if (!this.isSoldValueChanged && this.statusToggleBtnCtrl.value == 'sold' && !this.appliedFilter?.soldWithin) {
      delete jsonObject.soldWithin;
    }
    this.selectedFilters = this.propertyFilterService.getFilterDisplayList(jsonObject);
  }
  //statusToggleBtnCtrl subcirbe

  /**
   * @private
   */
  _resetFilter() {
    this.defaultListingTypeFilters = this.appState.companyInfoValue?.defaultPropertyFilter;
    this.filterForm.reset(this.defaultListingTypeFilters);
    this.propertyFilterService.setPrimaryFilterToUrl(this.filterForm.value);
    this.propertyFilterService.toggleFilterSheet();
  }

  /**
   * @private
   */
  _handleFilterAction() {
    this._saveFilters();
    if (this.applyToUrl) {
      this._applyFilter();
    }
    this.propertyFilterService.toggleFilterSheet();
  }

  /**
   * @private
   */
  _applyFilter(): void {
    if (this.filterForm.invalid) return;
    if (this.statusToggleBtnCtrl.value == 'sold') {
      this._resetListingTypeValue();
    } else {
      this.defaultFilterCheck(this.filterForm.value);
    }
    let modifiedFormValue = this.removeFalseValues(this.filterForm.value);
    this.propertyFilterService.setPrimaryFilterToUrl(modifiedFormValue);
  }

  defaultFilterCheck(modifiedFormValue) {
    if (
      !modifiedFormValue?.isForSale &&
      !modifiedFormValue?.isPreFcl &&
      !modifiedFormValue?.isReo &&
      !modifiedFormValue?.isAuction &&
      !modifiedFormValue?.isHud &&
      !modifiedFormValue?.isForRent
    ) {
      if (!this.isSoldValueChanged && !Object.keys(this.userDetails || {}).length) {
        modifiedFormValue.isForSale = true;
      }
      if (!this.isSoldValueChanged && Object.keys(this.userDetails || {}).length) {
        modifiedFormValue.isForSale = true;
        modifiedFormValue.isForRent = true;
      } else if (Object.keys(this.userDetails || {}).length) {
        this.defaultListingTypeFilters = this.appState.companyInfoValue?.defaultPropertyFilter;
        modifiedFormValue.isForSale = this.defaultListingTypeFilters.isForSale;
        modifiedFormValue.isPreFcl = this.defaultListingTypeFilters.isPreFcl;
        modifiedFormValue.isAuction = this.defaultListingTypeFilters.isAuction;
        modifiedFormValue.isReo = this.defaultListingTypeFilters.isReo;
        modifiedFormValue.isHud = this.defaultListingTypeFilters.isHud;
        modifiedFormValue.includePending = this.defaultListingTypeFilters.includePending;
      }
    }
  }
  /**
   * @private
   */
  _saveFilters() {
    this.propertyFilterService.saveSelectedFilters(this.filterForm.value);
  }

  private _handleBedBathFilter(): void {
    this.bedToggleBtnCtrl.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((value) => {
      this.filterForm.patchValue({ lBed: value, hBed: Number(this.filterForm.get('hBed').value) || null });
    });

    this.bathToggleBtnCtrl.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((value) => {
      this.filterForm.patchValue({ lBath: value, hBath: Number(this.filterForm.get('hBed').value) || null });
    });

    // merge(this.filterForm.get('lBed').valueChanges, this.filterForm.get('hBed').valueChanges)
    //   .pipe(takeUntil(this.onDestroyNotifier$), debounceTime(100))
    //   .subscribe(() => {
    //     this.bedToggleBtnCtrl.reset(null, { emitEvent: false });
    //   });

    // merge(this.filterForm.get('lBath').valueChanges, this.filterForm.get('hBath').valueChanges)
    //   .pipe(takeUntil(this.onDestroyNotifier$), debounceTime(100))
    //   .subscribe(() => {
    //     this.bathToggleBtnCtrl.reset(null, { emitEvent: false });
    //   });
  }

  // toggleSelection(homeType: any): void {
  //   const selectedHomeTypes = this.filterForm.get('homeType')?.value || [];
  //   const index = selectedHomeTypes.indexOf(homeType.value);
  //   console.log(selectedHomeTypes, 'selectedHomeTypes +++++++++++++');

  //   if (index === -1) {
  //     selectedHomeTypes.push(homeType.value);
  //   } else {
  //     selectedHomeTypes.splice(index, 1);
  //   }
  //   this.filterForm.get('homeType')?.setValue(selectedHomeTypes);
  // }
  // toggleSelection(homeType: any): void {
  //   // Safely retrieve the current value or default to an empty array
  //   let selectedHomeTypes = this.filterForm.get('homeType')?.value;

  //   // Ensure the value is an array
  //   if (!Array.isArray(selectedHomeTypes)) {
  //     selectedHomeTypes = [];
  //   }
  //   console.log(homeType,"homeType")
  //   const index = selectedHomeTypes.indexOf(homeType.value);

  //   // Add or remove the homeType from the array
  //   if (index === -1) {
  //     selectedHomeTypes.push(homeType.value);
  //   } else {
  //     selectedHomeTypes.splice(index, 1);
  //   } 

  //   console.log(homeType,"hometype",selectedHomeTypes)

  //   // Update the form control value
  //   this.filterForm.get('homeType')?.setValue(selectedHomeTypes);
  // }


  toggleSelection(homeType: any): void {
  let selectedHomeTypes = this.filterForm.get('homeType')?.value;

  // Ensure array
  if (!Array.isArray(selectedHomeTypes)) {
    selectedHomeTypes = [];
  }

  // Convert to array if single value
  const values = Array.isArray(homeType.value)
    ? homeType.value
    : [homeType.value];

  const allSelected = values.every((val: string) =>
    selectedHomeTypes.includes(val)
  );

  if (allSelected) {
    // Remove all values
    selectedHomeTypes = selectedHomeTypes.filter(
      (item: string) => !values.includes(item)
    );
  } else {
    // Add missing values
    values.forEach((val: string) => {
      if (!selectedHomeTypes.includes(val)) {
        selectedHomeTypes.push(val);
      }
    });
  }
  this.filterForm.get('homeType')?.setValue(selectedHomeTypes);
}
  isSelected(homeType: any): boolean {
    const selectedHomeTypes = this.filterForm.get('homeType')?.value || [];
     const values = Array.isArray(homeType.value)
    ? homeType.value
    : [homeType.value];
 
  return values.every((val: string) =>
    selectedHomeTypes.includes(val)
  );
  }

  _resetListingTypeValue() {
    this.filterForm.patchValue({
      isForSale: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.isForSale,
      isPreFcl: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.isPreFcl,
      isAuction: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.isAuction,
      isReo: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.isReo,
      isHud: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.isHud,
      includePending: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'rental' ? null : this.appliedFilter?.includePending,
      isForRent: this.statusToggleBtnCtrl.value == 'sold' || this.statusToggleBtnCtrl.value == 'forSale' ? null : this.appliedFilter?.isForRent,
    });
  }

  selectAll(event: MatCheckboxChange) {
    if (event.checked) {
      if (!Object.keys(this.userDetails || {}).length) {
        this.authorizeService.openLogInDialog();
        this._resetFilter();
        return (event.source.checked = false);
      } else {
        this.filterForm.patchValue({
          isPreFcl: true,
          isAuction: true,
          isReo: true,
        });
      }
    } else {
      this.filterForm.patchValue({
        isPreFcl: null,
        isAuction: null,
        isReo: null,
      });
    }
    this.allSelected = event.checked;
  }

  updateDistressStatus(event: MatCheckboxChange) {
    if (event.checked) {
      if (!Object.keys(this.userDetails || {}).length) {
        this.authorizeService.openLogInDialog();
        this._resetFilter();
        return (event.source.checked = false);
      }
    }
  }

  minMaxValidator(type: string, supportCtrlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.filterForm?.get(supportCtrlName)?.value || !control.value) return null;
      let minMaxError = false;
      if (type === 'min' && +control.value > +this.filterForm.get(supportCtrlName)?.value) {
        // (+) operator will convert a string to number
        minMaxError = true;
      } else if (type === 'max' && +this.filterForm.get(supportCtrlName).value > +control.value) {
        minMaxError = true;
      }
      if (minMaxError) {
        control.markAsTouched();
        this.filterForm?.markAsTouched();
        return { minMaxError: true };
      }
      return null; // No error
    };
  }
  isChecked() {
    return (
      this.filterForm.get('isAuction').value &&
      this.filterForm.get('isPreFcl').value &&
      this.filterForm.get('isReo').value
    );
  }
  isAllSelected() {
    if (this.isChecked()) {
      return false;
    }
    const isAnyTrue = ['isAuction', 'isPreFcl', 'isReo'].some((key) => this.filterForm.get(key).value);
    if (isAnyTrue) {
      this.isCheckedAll = false;
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
    return this.allSelected;
  }

  setFormControlValue(controlName: string, dateValue: any | undefined): void {
    if (dateValue && !isNaN(Date.parse(dateValue))) {
      const formattedDate = new Date(dateValue).toISOString().split('T')[0];
      this.filterForm.get(controlName)?.setValue(formattedDate);
    } else {
      this.filterForm.get(controlName)?.setValue(null);
    }
  }

  onDateChange(event: any, formControlName: string): void {
    const selectedDate = event.value;
    if (selectedDate) {
      const year = selectedDate.getFullYear();
      const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
      const day = selectedDate.getDate().toString().padStart(2, '0');
      this.filterForm.patchValue({ [formControlName]: `${year}-${month}-${day}` });
    }
  }

  soldValueChanges() {
    this.isSoldValueChanged = true;
  }

  removeFalseValues(obj) {
    if (obj.homeType?.length === 0 || (obj.homeType?.length === 1 && obj.homeType[0]?.length === 0)) {
      delete obj.homeType; // If true, delete homeType from obj
    }
    const filteredObject = { ...obj }; // Create a shallow copy of the object
    const keysToRemove = ['isForSale', 'isPreFcl', 'isAuction', 'isHud', 'includePending', 'isReo'];
    keysToRemove.forEach((key) => {
      if (filteredObject[key] === false) {
        delete filteredObject[key];
      }
    });
    return filteredObject;
  }

  validateYear(year: any, formValueName: string, minField: string, maxField: string) {
    year = year.value;
    const control = this.filterForm.get(formValueName);
    if (isNaN(year) || year.length !== 4 || year < 1000 || year > this.currentYear) {
      control.setErrors({ invalidYear: true });
      return;
    } else {
      control.setErrors(null);
    }
    this.validateMinMaxYears(minField, maxField);
  }

  validateMinMaxYears(minField: string, maxField: string) {
    const minControl = this.filterForm.get(minField);
    const maxControl = this.filterForm.get(maxField);
    if (minControl.value && maxControl.value && minControl.value > maxControl.value) {
      minControl.setErrors({ maxMinYear: true });
      maxControl.setErrors({ maxMinYear: true });
    } else {
      minControl.setErrors(null);
      maxControl.setErrors(null);
    }
  }

  convertStringBooleans(obj) {
    for (let key in obj) {
      if (obj[key] === null) {
        delete obj[key];
        continue;
      }
      if (typeof obj[key] === 'string') {
        const trimmedValue = obj[key].trim();
        if (trimmedValue === 'true') {
          obj[key] = true;
        } else if (trimmedValue === 'false') {
          obj[key] = false;
        } else if (trimmedValue !== '') {
          const numericValue = Number(trimmedValue);
          if (!Number.isNaN(numericValue)) {
            obj[key] = numericValue;
          }
        }
      }
    }
    return obj;
  }

  toggleDropdown(controlName: string) {
    this.showDropdown[controlName] = !this.showDropdown[controlName];
    this.cdr.detectChanges();
  }

  selectPrice(item: any, controlName: string) {
    const value = Number(item.value);
    this.filterForm.patchValue({
      [controlName]: value,
    });
    this.showDropdown[controlName] = false;
    this.cdr.detectChanges();
  }

  onType(event: any, controlName: string) {
    let rawValue = event.target.value;
    const cleaned = rawValue.replace(/\$/g, '').replace(/,/g, '');
    if (!cleaned) {
      this.filterForm.patchValue({ [controlName]: null }, { emitEvent: false });
      this.showDropdown[controlName] = false;
      return;
    }
    const numericValue = Number(cleaned);
    if (isNaN(numericValue)) {
      return;
    }
    this.showDropdown[controlName] = false;
    this.filterForm.patchValue({ [controlName]: numericValue }, { emitEvent: false });
    this.cdr.detectChanges();
  }

  getCapRateDisableStatus() {
    return !this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.capRates.key, false);
  }

  updateCapRateControlState() {
    const isDisabled = !this.subscriptionService.checkFeatureValidity(
      constants.PLAN_BASED_FEATURES.capRates.key,
      false
    );

    const lControl = this.filterForm.get('lCapRate');
    const hControl = this.filterForm.get('hCapRate');

    if (!lControl || !hControl) return;

    if (isDisabled && lControl.enabled) {
      lControl.disable({ emitEvent: false });
      hControl.disable({ emitEvent: false });
    } else if (!isDisabled && lControl.disabled) {
      lControl.enable({ emitEvent: false });
      hControl.enable({ emitEvent: false });
    }
  }

  getForeclosureDisableStatus() {
    return !this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.foreclosures.key, false);
  }

  updateForeclosureControlState() {
    const isDisabled = !this.subscriptionService.checkFeatureValidity(
      constants.PLAN_BASED_FEATURES.foreclosures.key,
      false
    );

    const fControl = this.filterForm.get('isPreFcl');
    const aControl = this.filterForm.get('isAuction');
    const reoControl = this.filterForm.get('isReo');
    const hudControl = this.filterForm.get('isHud');

    if (!fControl || !aControl || !reoControl || !hudControl) return;

    if (isDisabled && fControl.enabled) {
      fControl.disable({ emitEvent: false });
      aControl.disable({ emitEvent: false });
      reoControl.disable({ emitEvent: false });
      hudControl.disable({ emitEvent: false });
    } else if (!isDisabled && fControl.disabled) {
      fControl.enable({ emitEvent: false });
      aControl.enable({ emitEvent: false });
      reoControl.enable({ emitEvent: false });
      hudControl.enable({ emitEvent: false });
    }
  }

}
